import { useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "@/data/content";

export default function Header({ onJoin }) {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 bg-[#0A0A0A]/90 backdrop-blur-xl border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 md:h-20 flex items-center justify-between">
        <a href="#home" data-testid="logo-link" className="flex items-center gap-2.5">
          <span className="w-9 h-9 rounded-md bg-[#FF5A1F] flex items-center justify-center shadow-[0_0_18px_rgba(255,90,31,0.45)]">
            <span className="font-wordmark text-[#0A0A0A] text-[13px] leading-none">F12</span>
          </span>
          <span className="font-wordmark text-2xl md:text-[1.65rem] leading-none text-[#FF5A1F]">
            F12<span className="font-semibold">Fitness</span>
          </span>
        </a>

        <nav data-testid="desktop-nav" className="hidden lg:flex items-center gap-7">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              data-testid={`nav-${l.label.toLowerCase()}-link`}
              href={l.href}
              className="text-xs font-semibold uppercase tracking-[0.18em] text-[#D1D1D1] hover:text-[#FF5A1F] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-join-now-button"
            onClick={onJoin}
            className="hidden sm:inline-flex bg-[#FF5A1F] hover:bg-[#E0480F] text-white font-heading text-lg tracking-widest px-6 py-2 rounded-sm transition-colors shadow-[0_0_22px_rgba(255,90,31,0.35)]"
          >
            JOIN NOW
          </button>
          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden text-white p-1"
            onClick={() => setOpen(!open)}
            aria-label="Toggle navigation menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <nav
          data-testid="mobile-menu"
          className="lg:hidden bg-[#0A0A0A] border-t border-white/10 px-4 py-4 flex flex-col"
        >
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              data-testid={`mobile-nav-${l.label.toLowerCase()}-link`}
              href={l.href}
              onClick={() => setOpen(false)}
              className="py-3 text-sm font-semibold uppercase tracking-[0.18em] text-[#D1D1D1] hover:text-[#FF5A1F] border-b border-white/5 transition-colors"
            >
              {l.label}
            </a>
          ))}
          <button
            data-testid="mobile-join-now-button"
            onClick={() => {
              setOpen(false);
              onJoin();
            }}
            className="mt-4 bg-[#FF5A1F] hover:bg-[#E0480F] text-white font-heading text-lg tracking-widest px-6 py-3 rounded-sm transition-colors"
          >
            JOIN NOW
          </button>
        </nav>
      )}
    </header>
  );
}
